import { ca } from '@cian/analytics';
import { parseCookies } from '@cian/utils/lib/shared/cookie';
import { ITeaserEvent } from '../../types/teaser';
import { getViewportDimensions } from '../../utils/viewport/getViewportDimensions';
import { sendTeaserEvent } from '../../services/teaser';

interface IParams {
  userId: number | null;
  abGroup: number;
  name: string;
  soprApi: string;
}

export function trackShowMortgageBanner(params: IParams) {
  const event: ITeaserEvent = {
    user_id: params.userId,
    pageType: 'Map',
    device_type: 'phone',
    ab_group: params.abGroup,
    viewport: getViewportDimensions(),
    cid: parseCookies(document.cookie)['_CIAN_GK'],
    items: [
      {
        block_type: 'mortgage_widget',
        isTeaserShow: true,
        name: params.name,
      },
    ],
  };

  sendTeaserEvent(params.soprApi, event);
}

export const trackGoToMortgagePageClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_to_mortgage',
    category: 'BannerIpoteka',
    label: 'fullscreen_percent',
  });
};

export const trackDoNotShowClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_not_now',
    category: 'BannerIpoteka',
    label: 'fullscreen_percent',
  });
};
